import { makeEntityScaffold } from '@classpass/saga-tools';
import _has from 'lodash/has';
import _mapValues from 'lodash/mapValues';

import URLS from 'constants/urls';
import { transformKeysToCamelCase, trimTimezone } from 'helpers/core';
import { VENUE_FEATURE_PROBE_HTTP_CONFIG } from 'helpers/session-auth-http';

function mergeInstances(oldInstances, newInstances) {
  const instances = {};

  Object.keys({ ...oldInstances, ...newInstances }).forEach(key => {
    if (_has(newInstances, key) && _has(oldInstances, key)) {
      instances[key] = [...oldInstances[key], ...newInstances[key]];
    } else if (_has(newInstances, key)) {
      instances[key] = [...newInstances[key]];
    } else {
      instances[key] = [...oldInstances[key]];
    }
  });

  return instances;
}

const trimTimezonesFromScheduleInstance = ({ schedule, startingAt, ...rest }) => ({
  ...rest,
  startingAt: trimTimezone(startingAt),
  schedule: {
    ...schedule,
    startDate: trimTimezone(schedule.startDate),
    recurrenceEndDate: trimTimezone(schedule.recurrenceEndDate),
  },
});

const trimTimezonesFromPayload = data =>
  _mapValues(data, schedulesGroup => schedulesGroup.map(trimTimezonesFromScheduleInstance));

function get(httpClient, venueId, filters, pageDate, previousInstances) {
  return httpClient
    .get(URLS.msSchedules.scheduleInstancesByDay(venueId, filters, pageDate), VENUE_FEATURE_PROBE_HTTP_CONFIG)
    .then(response => transformKeysToCamelCase(response.data))
    .then(({ data, meta }) => ({
      instances: mergeInstances(previousInstances, trimTimezonesFromPayload(data)),
      nextDate: meta.nextDate,
    }));
}

function handler({ httpClient }, venueId, filters, pageDate, previousInstances = {}) {
  return get(httpClient, venueId, filters, pageDate, previousInstances);
}

export default makeEntityScaffold('SAGA.API.FETCH_SCHEDULES_INSTANCES', handler, {
  defaultKey: (client, { venueId }) => venueId,
});
